import Typed from 'typed.js';
import ShuffleText from "shuffle-text";
import { render } from './data';

render();


  const btn = document.getElementById("themeToggle");
  const paragraphs = document.querySelectorAll("p");
  const sidebar = document.querySelectorAll(".sections");
  const sections = document.querySelectorAll("section");
  const skillCards = document.querySelectorAll(".skill-group1-1");

  const catBtn = document.querySelectorAll(".cat-p1");
  const cards = document.querySelectorAll(".pro-2");


  //////////////////////////////////////////////////////////
  // theme change
  btn.addEventListener("click", () => {
    document.body.classList.toggle("light-theme");

    if (document.body.classList.contains("light-theme")) {
        paragraphs.forEach(p => p.style.color = "black");
        btn.textContent = "🌙"; 
    } else {
        paragraphs.forEach(p => p.style.color = "");
        btn.textContent = "☀️"; 
    }
  });
//////////////////////////////////////////////////////////

//////////////////////////////////////////////////////
// typing animation
const typed = new Typed('#element', {
  strings: ["Hi, I'm Suraj Maru", 'A Web Developer', 'A Coder', 'A YouTuber'],
  typeSpeed: 100,
  backSpeed: 40,
  loop: true,
});
/////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////
// mouse movement animation
skillCards.forEach(card => {
  card.addEventListener("mousemove", (e)=>{
    const rect = card.getBoundingClientRect();

    // console.log(e);
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
  
    const centerX = rect.width / 2;
    const centerY = rect.width / 2;

    const moveX = (x - centerX) / 15;
    const moveY = (y - centerY) / 15;

    card.style.transform = `translate(${moveX}px, ${moveY}px) scale(1.03)`;
  })

  card.addEventListener("mouseleave", ()=>{
    card.style.transform = `translate(0,0) scale(1)`
  })
});
/////////////////////////////////////////////////////////////

catBtn.forEach(btn => {
  btn.addEventListener("click", () => {
    const category = btn.dataset.category;

    catBtn.forEach(b => b.classList.remove("cat-active"));
    btn.classList.add("cat-active");

    let delay = 0;

    cards.forEach(card => {
      const match = card.classList.contains(category);

      if (match) {
        card.classList.remove("removed");
        card.style.transitionDelay = `${delay}s`;

        requestAnimationFrame(() => {
          card.classList.remove("hidden");
        });

        delay += 0.08; // stagger effect
      } else {
        card.classList.add("hidden");
        card.classList.add("removed");
        card.style.transitionDelay = "0s";
      }
    });
  });
});

//////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////
// text effect
const el = document.querySelector(".head-p");

if (el) {
  const shuffle = new ShuffleText(el);

  el.addEventListener("mouseenter",()=>{

    // shuffle.setText("SURAJ MARU");
    shuffle.start();
  });

//   el.addEventListener("mouseleave", () => {
//   shuffle.stop();
// });

}
/////////////////////////////////////////////////////////////////////

// Live youtube stats display.
////////////////////////////////////////////////////////////////////
const apiKey = 'AIzaSyAZ9MNp1bij-a4PWG8rhJ90QxiHfgBb3-I'; 
const channelId = 'UCUDSEMu5pgsZqhUR27RBM8g'; 

const videoIds = {
  airMouse: "xLPF6gYPwzA",
  jarvis: "GVieIRUcs5w"
};

async function fetchSubscriberCount() {
  try {
    const response = await fetch(`https://www.googleapis.com/youtube/v3/channels?part=statistics&id=${channelId}&key=${apiKey}`);
    const data = await response.json();
    const stats = data.items[0].statistics;

    const subs = Number(stats.subscriberCount).toLocaleString();
    const videos = Number(stats.videoCount).toLocaleString();
    const views = Number(stats.viewCount).toLocaleString();

    document.getElementById('yt-subs').innerText = subs;
    document.getElementById('yt-videos').innerText = videos;
    document.getElementById('yt-views').innerText = views;


        /* ---------- VIDEO STATS ---------- */
    const videoIdString = Object.values(videoIds).join(",");

    const videoRes = await fetch(
      `https://www.googleapis.com/youtube/v3/videos?part=statistics&id=${videoIdString}&key=${apiKey}`
    );
    const videoData = await videoRes.json();

    videoData.items.forEach(video => {
      const views = Number(video.statistics.viewCount).toLocaleString();

      if (video.id === videoIds.airMouse) {
        document.getElementById("airmouse-views").innerText = views;
      }

      if (video.id === videoIds.jarvis) {
        document.getElementById("jarvis-views").innerText = views;
      }
    });

  } catch (error) {
    console.error('Error fetching subscriber count:', error);
  }
}

fetchSubscriberCount();

setInterval(fetchSubscriberCount, 300000);
/////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////
// button visibility depending on section
const upArrow = document.querySelector(".up-arrow");
const sectionHome = document.querySelector(".section-home");

    function handleHomeVisibility(entry){
    
      if(entry.isIntersecting){
        upArrow.classList.add("hidden");
      } else{
        upArrow.classList.remove("hidden");
      }
  }


  const navHeight2 = sectionHome.getBoundingClientRect().height;
  const observer2 = new IntersectionObserver(([entry]) => { 
   
      handleHomeVisibility(entry);
  
  }, {
    root:null,
    threshold: 0,
  })
  observer2.observe(sectionHome);

  // smooth scroll to top

  upArrow.addEventListener("click", function(){
    window.scrollTo({
      top:0,
      behavior:'smooth',
    });
  });



//////////////////////////////////////////////////////////////////////
  
  // nav tap to scroll feature
  sidebar.forEach(ele => {
    const targetId = ele.dataset.target;
    const sectionn = document.getElementById(targetId);

    if(!sectionn) return;

    ele.addEventListener("click",function(){

      sectionn.scrollIntoView({
        behavior:'smooth',
        block:"start",
      })

    })
  })

  // nav buttons dynamic change as per sections.

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach(entry => {
      const id = entry.target.id;
      // console.log(id);
      const navItem = document.querySelector(
        `.sections[data-target="${id}"]`
      );

      if (!navItem) return;

      if (entry.isIntersecting) {
        sidebar.forEach(item =>
          item.classList.remove("cat-on")
        );
        navItem.classList.add("cat-on");
      }
    });
  },
  {
    root: null,
    threshold: 0.3,
  }
);

sections.forEach(section => observer.observe(section));
//////////////////////////////////////////////////////

const c = document.getElementById("bg");
const ctx = c.getContext("2d");

function resize() {
  c.width = innerWidth;
  c.height = innerHeight;
}
resize();
addEventListener("resize", resize);

const mouse = {
  x: null,
  y: null,
  active: false
};

addEventListener("mousemove", e => {
  mouse.x = e.clientX;
  mouse.y = e.clientY;
  mouse.active = true;
});

addEventListener("mouseleave", () => {
  mouse.active = false;
});

let dots = Array.from({ length: 80 }, () => ({
  x: Math.random() * c.width,
  y: Math.random() * c.height,
  r: Math.random() * 3,
  dx: (Math.random() - 0.5) * 0.4,
  dy: (Math.random() - 0.5) * 0.4
}));

function animate() {
  ctx.clearRect(0, 0, c.width, c.height);
  ctx.fillStyle = "rgba(255,255,255,0.35)";

  dots.forEach(d => {

    d.x += d.dx;
    d.y += d.dy;

    if (mouse.active) {
      const distX = mouse.x - d.x;
      const distY = mouse.y - d.y;
      const distance = Math.sqrt(distX * distX + distY * distY);

      const maxDist = 150;

      if (distance < maxDist) {
        const force = (maxDist - distance) / maxDist;
        d.x += distX * force * 0.02;
        d.y += distY * force * 0.02;
      }
    }

    if (d.x < 0) d.x = c.width;
    if (d.x > c.width) d.x = 0;
    if (d.y < 0) d.y = c.height;
    if (d.y > c.height) d.y = 0;

    ctx.beginPath();
    ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
    ctx.fill();
  });

  requestAnimationFrame(animate);
}

animate();
////////////////////////////////////////////

///////////////////////////////////////////
// sections reveal animations

const reveals = document.querySelectorAll(".reveal, .reveal2");
// const reveals2 = document.querySelectorAll(".reveal2");

const observerAnimation = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        entry.target.classList.add("show");
        // observer.unobserve(entry.target);
      }
       else{
        entry.target.classList.remove("show");
      }
    });
  },
  {
    threshold: 0.15,
  }
);

window.addEventListener("load", () => {
  setTimeout(() => {
    document.body.classList.add("ready");
    reveals.forEach((el, i) => observerAnimation.observe(el));
  }, 800); // matches loader duration
});


// window.addEventListener("load", () => {
//   setTimeout(() => {
//     document.getElementById("intro")?.remove();
//   }, 2000);
// });

////////////////////////////////////////////////

const footerYear = document.querySelector(".contact-footer-year");
footerYear.textContent = new Date().getFullYear();